// utils/audio/resolveAudioUrl.js

export default function resolveAudioUrl(sampleLink, apiUrl) {
  if (!sampleLink) return null;

  // ja és URL completa
  if (sampleLink.startsWith("http")) return sampleLink;

  // normalitza slash
  const normalized = sampleLink.startsWith("/")
    ? sampleLink
    : `/${sampleLink}`;

  // si tens API → attach domain
  if (apiUrl) {
    const base = apiUrl.replace("/api", "");
    return `${base}${normalized}`;
  }

  return normalized;
}